import { DropdownButtonType, List, ListItem, SingleSelectDropdown, TabStyles } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';

import { PoolAssignmentOption } from '../../types/PoolAssignmentOption';
import { PoolID } from '../../types/PoolID';

export type PoolAssignmentDropdownProps = Readonly<{
    onPoolAssignmentChange: (poolID: PoolID | null) => void;
    assignedPoolID: PoolID | null;
    poolOptions: ReadonlyArray<PoolAssignmentOption>;
}>;

export function PoolAssignmentDropdown(props: PoolAssignmentDropdownProps) {
    const onChange = (poolDisplayName: string) => {
        const option: PoolAssignmentOption =
            props.poolOptions.find((option: PoolAssignmentOption) => option.poolDisplayName === poolDisplayName);
        props.onPoolAssignmentChange(option.poolID);
    };
    const selectedOption: PoolAssignmentOption | undefined =
        props.poolOptions.find((option: PoolAssignmentOption) => option.poolID === props.assignedPoolID);

    return (
        <SingleSelectDropdown
            children={selectedOption ? null : Messages.bridgeSiteSettingsPoolDropdownPlaceholder()}
            testId={'pool-assignment-dropdown'}
            type={DropdownButtonType.Outline}
            list={<List items={createListItemsForDropdown(props.poolOptions)} />}
            disabled={false}
            value={selectedOption?.poolDisplayName}
            onChange={onChange}
            label={Messages.bridgeSiteSettingsPool()}
            className={poolAssignmentClass}
        />
    );
}

function createListItemsForDropdown(poolOptions: ReadonlyArray<PoolAssignmentOption>): ListItem[] {
    return poolOptions.map((option: PoolAssignmentOption) => {
        return {
            value: option.poolDisplayName
        };
    });
}

const poolAssignmentClass = cssClass('pool-assignment-dropdown', 'root', {
    marginTop: TabStyles.Spacing.LargeSpace,
    marginBottom: TabStyles.Spacing.ExtraLargeSpace,
});
